export default "/images/vendor/@coreui/icons/svg/flag/cif-ae.svg?ee78c107a2022ecfd59b79cd853f2906";